import React from "react";
import RegisterRealtorComponent from "../../component/RegisterRealtor";

const RegisterRealtorPage = () => {
  return (
    <div>
      <RegisterRealtorComponent />
    </div>
  );
};

export default RegisterRealtorPage;
